<template>
  <div class="person-type">
    <question-template
      name="taxType"
      :info="info"
      :showTutorials="showTutorials"
    />
    <tutorial />
  </div>
</template>

<script>
import Tutorial from "./Tutorial.vue";

export default {
  name: "PersonType",
  components: {
    tutorial: Tutorial,
  },
  computed: {
    showTutorials() {
      return this.$store.getters["app/getApp"].showPersonTypeTutorial;
    },
  },
  data() {
    return {
      info: {
        title: "ต่างกันยังไง",
        path: "/info/person_type_definition",
      },
    };
  },
};
</script>

<style scoped></style>
